import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';

export const DatabaseIconFragmentGql: DocumentNode = gql`
fragment DatabaseIconFragment on Database {
  __typename
  connectionType
  isCertified
  certificationNote
}
`;
